import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZRead = z.object({
  readingTime: z.string(),
  count: z.number().nullable()
})

const ZDeviceKPIReadingcimCodeIds = z.object({
  paraMeterId: z.string(),
  paraMeterName: z.string(),
  unit: z.string(),
  paraMeterReading: z.array(ZRead)
})

const ZAssetKPIReadingcimCodeIds = z.object({
  paraMeterId: z.string(),
  paraMeterName: z.string(),
  unit: z.string(),
  paraMeterReading: z.array(ZRead)
})

const ZDeviceKPIReadingcimCodeIdsDetails = z.object({
  deviceId: z.string(),
  deviceName: z.string(),
  paraMeterReadings: z.array(ZDeviceKPIReadingcimCodeIds)
})

const ZAssetKPIReadingcimCodeIdsDeatils = z.object({
  assetId: z.string(),
  assetName: z.string(),
  paraMeterReadings: z.array(ZAssetKPIReadingcimCodeIds)
})

const ZIntervalReadingAssetData = z.object({
  deviceReadings: z.array(ZDeviceKPIReadingcimCodeIdsDetails),
  assetReadings: z.array(ZAssetKPIReadingcimCodeIdsDeatils)
})

export const ZApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: ZIntervalReadingAssetData
})

export type AlertTrendKPIDataAssetDashboard = z.infer<typeof ZIntervalReadingAssetData>
export type AlertTrendKPIAssetData = z.infer<typeof ZApiResponse>

export async function getAlertTrendKPIAssetDashboardData (
  startDate: string,
  endDate: string,
  graphName: string,
  requestParameter: any,
  intervalGroup: string,
  isdefault: boolean,
  onSuccess: (AlertTrendKPIData: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/kpirest/api/v1/udp/tiq/dashboard/asset/alertTrend/data?startDate=${startDate}&endDate=${endDate}&graphName=${graphName}&intervalGroup=${intervalGroup}&isDefault=${isdefault.toString()}`
  interceptedAxios
    .post(url, requestParameter, {
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          if (response.data.data !== null && response.data.data !== undefined) {
            onSuccess(parseResponse.data.data, response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      } else if (response.status === 204) {
        onFailure('No Content', response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
